import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Button } from '../components/ui/Button';
import { motion } from 'framer-motion';
import { Monitor, Users, Crown, Check, Briefcase, PartyPopper, Star, Download, Calendar } from 'lucide-react';
import { Link } from 'react-router-dom';
export function CorporateEvents() {
  const features = [{
    icon: Monitor,
    title: 'Business Presentations',
    description: 'Utilize our 190ft immersive screen for impactful presentations, product launches, and corporate announcements.'
  }, {
    icon: PartyPopper,
    title: 'Celebrations & Mixers',
    description: 'The perfect backdrop for birthday celebrations, social mixers, and private affairs with customizable entertainment.'
  }, {
    icon: Crown,
    title: 'VIP Experiences',
    description: 'Exclusive access to our premium spaces with dedicated staff, custom menus, and bottle service packages.'
  }];
  const packages = [{
    icon: Briefcase,
    title: 'Executive Package',
    description: 'Perfect for board meetings and executive gatherings. Includes private dining area, A/V equipment, and premium catering.',
    price: 'Starting at $2,500',
    capacity: 'Up to 25 guests',
    image: 'https://images.unsplash.com/photo-1511795409834-ef04bbd61622?q=80&w=1000&auto=format&fit=crop'
  }, {
    icon: PartyPopper,
    title: 'Team Celebration Package',
    description: 'Celebrate milestones with style. Full venue access, DJ, custom menu, and entertainment on our massive screen.',
    price: 'Starting at $5,000',
    capacity: 'Up to 100 guests',
    image: 'https://images.unsplash.com/photo-1519671482749-fd09be7ccebf?q=80&w=1000&auto=format&fit=crop'
  }, {
    icon: Star,
    title: 'Premium Corporate Package',
    description: 'The ultimate corporate experience. Entire venue buyout, celebrity host, premium bottle service, and custom entertainment.',
    price: 'Starting at $15,000',
    capacity: 'Up to 200+ guests',
    image: 'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?q=80&w=1000&auto=format&fit=crop'
  }];
  const includedItems = ['Dedicated event coordinator', '190ft immersive video wall access', 'Premium sound system', 'Custom menu options', 'VIP bottle service', 'Professional staff service', 'Customizable lighting & ambiance', 'Complimentary WiFi'];
  return <div className="min-h-screen bg-[#0B1014] text-white selection:bg-[#DDA247] selection:text-[#0B1014]" data-id="element-1153">
      <Header data-id="element-1154" />

      <main className="pt-24 md:pt-44 pb-16 px-4 md:px-8 max-w-[1600px] mx-auto" data-id="element-1155">
        {/* Hero Section */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="relative h-[400px] md:h-[550px] rounded-3xl overflow-hidden mb-16" data-id="element-1156">
          <img src="https://cdn.magicpatterns.com/uploads/6LnQJuHyfQwVZFXw8tjh5d/SnapInsta.to_683098766_18095297579328170_3814077117280607925_n.jpg" alt="Private Events Venue" className="absolute inset-0 w-full h-full object-cover" data-id="element-1157" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0B1014] via-[#0B1014]/60 to-transparent" data-id="element-1158" />
          <div className="absolute inset-0 flex flex-col justify-center p-8 md:p-16" data-id="element-1159">
            <div className="max-w-3xl" data-id="element-1160">
              <span className="inline-block px-4 py-1 bg-[#DDA247] text-[#0B1014] font-black text-xs uppercase tracking-widest mb-6" data-id="element-1161">
                Bespoke Affairs • Corporate & Private
              </span>
              <h1 className="text-3xl md:text-6xl font-black text-white mb-6 tracking-tight uppercase leading-none" data-id="element-1162">
                Private <span className="text-[#DDA247]" data-id="element-1163">Events</span>
              </h1>
              <p className="text-lg md:text-xl text-gray-200 max-w-2xl leading-relaxed mb-8" data-id="element-1164">
                Looking for the perfect space to host a business mixer, birthday
                celebration, or private affair? House of Flavor offers luxury
                and flexibility for groups with our 190ft immersive video wall
                and premium amenities.
              </p>
              <Link to="/contact" data-id="element-1165">
                <Button variant="primary" size="lg" data-id="element-1166">
                  Request a Quote
                </Button>
              </Link>
            </div>
          </div>
        </motion.div>

        {/* Feature Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-1167">
          {features.map((feature, index) => <motion.div key={feature.title} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.15,
          duration: 0.6
        }} className="bg-[#11161A] border border-white/5 p-8 text-center group hover:border-[#DDA247]/30 transition-colors duration-300" data-id="element-1168">
              <div className="inline-flex items-center justify-center w-16 h-16 mb-6 bg-[#DDA247]/10 rounded-full group-hover:bg-[#DDA247]/20 transition-colors duration-300" data-id="element-1169">
                <feature.icon className="w-8 h-8 text-[#DDA247]" data-id="element-1170" />
              </div>
              <h3 className="text-xl font-bold text-white mb-4 tracking-wide" data-id="element-1171">
                {feature.title}
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-1172">
                {feature.description}
              </p>
            </motion.div>)}
        </div>

        {/* Event Packages */}
        <div className="mb-16" data-id="element-1173">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-12" data-id="element-1174">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 tracking-wide" data-id="element-1175">
              EVENT PACKAGES
            </h2>
            <div className="w-16 h-1 bg-[#DDA247] mx-auto" data-id="element-1176" />
          </motion.div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-1177">
            {packages.map((pkg, index) => <motion.div key={pkg.title} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.15,
            duration: 0.6
          }} className="bg-[#11161A] border border-white/10 rounded-2xl flex flex-col relative overflow-hidden group hover:border-[#DDA247]/50 transition-all duration-300" data-id="element-1178">
                <div className="relative h-48 overflow-hidden" data-id="element-1179">
                  <img src={pkg.image} alt={pkg.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-1180" />
                  <div className="absolute inset-0 bg-[#0B1014]/40" data-id="element-1181" />
                  <div className="absolute bottom-4 left-4" data-id="element-1182">
                    <span className="px-3 py-1 bg-[#DDA247] text-[#0B1014] font-black text-[10px] uppercase tracking-widest rounded-full" data-id="element-1183">
                      {pkg.capacity}
                    </span>
                  </div>
                </div>

                <div className="p-8 flex flex-col flex-grow" data-id="element-1184">
                  <div className="mb-6" data-id="element-1185">
                    <pkg.icon className="w-10 h-10 text-[#DDA247] mb-4" data-id="element-1186" />
                    <h3 className="text-2xl font-bold text-white mb-2" data-id="element-1187">
                      {pkg.title}
                    </h3>
                    <p className="text-gray-400 text-sm leading-relaxed mb-6 min-h-[60px]" data-id="element-1188">
                      {pkg.description}
                    </p>
                  </div>

                  <div className="mt-auto pt-6 border-t border-white/10" data-id="element-1189">
                    <div className="flex flex-col gap-1 mb-6" data-id="element-1190">
                      <span className="text-[#DDA247] font-bold text-lg" data-id="element-1191">
                        {pkg.price}
                      </span>
                      <span className="text-gray-500 text-sm font-medium uppercase tracking-wider" data-id="element-1192">
                        {pkg.capacity}
                      </span>
                    </div>
                    <Link to="/contact" data-id="element-1193">
                      <Button variant="primary" fullWidth data-id="element-1194">
                        Request Corporate Quote
                      </Button>
                    </Link>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>

        {/* What's Included */}
        <div className="mb-16 bg-[#11161A] border border-white/5 rounded-2xl p-8 md:p-12" data-id="element-1195">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-12" data-id="element-1196">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 tracking-wide" data-id="element-1197">
              WHAT'S INCLUDED
            </h2>
            <div className="w-16 h-1 bg-[#DDA247] mx-auto" data-id="element-1198" />
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1199">
            {includedItems.map((item, index) => <motion.div key={item} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05
          }} className="flex items-center space-x-3 bg-[#0B1014] p-4 rounded border border-white/5" data-id="element-1200">
                <Check className="w-5 h-5 text-[#DDA247] flex-shrink-0" data-id="element-1201" />
                <span className="text-gray-300 text-sm font-medium" data-id="element-1202">
                  {item}
                </span>
              </motion.div>)}
          </div>
        </div>

        {/* CTA Section */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative rounded-3xl overflow-hidden" data-id="element-1203">
          <div className="absolute inset-0 bg-gradient-to-r from-[#DDA247]/20 to-[#0B1014] z-0" data-id="element-1204" />
          <div className="absolute inset-0 bg-[#0B1014]/80 z-0" data-id="element-1205" />

          <div className="relative z-10 p-10 md:p-16 text-center" data-id="element-1206">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 uppercase tracking-wide" data-id="element-1207">
              Ready to Plan Your Corporate Event?
            </h2>
            <p className="text-gray-300 text-lg max-w-2xl mx-auto mb-10" data-id="element-1208">
              Contact our corporate events team to discuss your vision and
              receive a custom proposal.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-6" data-id="element-1209">
              <Link to="/contact" data-id="element-1210">
                <Button variant="primary" size="lg" data-id="element-1211">
                  <Calendar className="w-5 h-5 mr-2" data-id="element-1212" />
                  Schedule Consultation
                </Button>
              </Link>
              <Button variant="outline" size="lg" data-id="element-1213">
                <Download className="w-5 h-5 mr-2" data-id="element-1214" />
                Download Brochure
              </Button>
            </div>
          </div>
        </motion.div>
      </main>

      <Footer data-id="element-1215" />
    </div>;
}